define(function (require) {

    window.lpTag = window.lpTag || {};

    var _ = require('underscore');
    var ViewController = require('web-agent-framework/ViewController');


    /**
     * Table View Controller
     */
    var TabsViewController = ViewController.extend({
        ControllerName: "TabsViewController",
        applicationType: 'TabsViewController',
        templateFile: "LP_tabs_component.html",

        LPViewMap: {
            container: '.lpview_tabs_container',
            tabButton: '.lpview_tab_button',
            tabsStrip: '.lpview_tabs_strip',
            viewPort: '.lpview_view_port'

        },
        LPViewClasses: {
            tabContainer: 'tab_container'
        },
        LPClassesMap: {
            active: 'active'
        },

        initialize: function (constructorData) {
            this.viewPort = this.getFirstElement(this.LPViewMap.viewPort);
            this.config = {
                tabs: constructorData.tabs || [],
                selectedTabIndex: constructorData.selectedTabIndex,
                events: {
                    onTabSelectionChange: constructorData.onTabSelectionChange
                }
            };
            this.initView();
        },
        events: function () {
        },
        render: function () {
        }
    });


    /**
     * Initialize the View of the component.
     */
    TabsViewController.prototype.initView = function () {
        this.tabs = [];

        // create the tab's string.
        // init the view port and sub controllers.
        for (var i = 0; i < this.config.tabs.length; i++) {
            //var currentTab = ;
            this.addTab(this.config.tabs[i], i);
        }

        this.setActiveTab(this.config.selectedTabIndex || 0);

    };


    TabsViewController.prototype.addTab = function (tabConfig, index) {
        if (typeof index === 'undefined') {
            index = (this.tabs.length );
        }

        // Creating the button
        var button = this.createView({
            target: this.LPViewMap.tabsStrip,
            textInjection: {
                title: tabConfig.title,
                tooltip: tabConfig.tooltip,
                index: index
            },
            wrapWithDiv: false,
            templateFile: 'LP_tabs_component_tabbutton.html'
        });

        var containerView = this.createView({
            elementType: 'div',
            className: this.LPViewClasses.tabContainer,
            target: this.viewPort
        });

        // Attaching the view into the view port
        if (tabConfig.view instanceof ViewController) {
            this.addViewController({target: containerView, viewController: tabConfig.view});

            // create a communication channel between the tabs and the views.
            if (tabConfig.view.registerTabsManager && typeof  tabConfig.view.registerTabsManager === 'function') {
                tabConfig.view.registerTabsManager(this, index);
            }

        } else {
            this.addView({targetView: containerView, viewToAdd: tabConfig.view});
        }

        if (tabConfig.icon) {
            this.addClass(button, 'icon-' + tabConfig.icon);
        }
        this.tabs.push({button: button, view: containerView, config: tabConfig});

        this.bindViewEvent({
            view: button,
            DOMEvent: "click",
            callback: this.onTabButtonClicked.bind(this)
        });
    };

    /**
     * Set the Active Tab.
     * @param index - the index to show.
     */
    TabsViewController.prototype.setActiveTab = function (index) {
        if (typeof index !== 'undefined' && this.selectedTabIndex !== index) {
            if (typeof this.selectedTabIndex !== 'undefined' && this.selectedTabIndex !== null) {
                this.removeClass(this.tabs[this.selectedTabIndex].view, this.LPClassesMap.active);
                this.removeClass(this.tabs[this.selectedTabIndex].button, this.LPClassesMap.active);
            }

            this.selectedTabIndex = index;
            this.addClass(this.tabs[index].view, this.LPClassesMap.active);
            this.addClass(this.tabs[index].button, this.LPClassesMap.active);

            if(_.isFunction(this.config.events.onTabSelectionChange)){
                this.config.events.onTabSelectionChange.call(this, index);
            }
        }
    };

    /**
     * get the current Scroll Position.
     */
    TabsViewController.prototype.getScrollPosition = function(){
        return this.viewPort.scrollTop || 0;
    };

    /**
     * Setting the Scroll Position.
     * @param position
     */
    TabsViewController.prototype.setScrollPosition = function(position){
        this.viewPort.scrollTop = position;
    };



    /**
     * Set the Tab Title
     * @param index - the index of the tab
     * @param title - the title of the tab.
     */
    TabsViewController.prototype.setTabTitle = function (index, title) {
        if (this.tabs && this.tabs.length && this.tabs[index] && this.tabs[index].button) {
            this.tabs[index].button.innerText = title;
            this.tabs[index].button.textContent = title; // adding support for FF.
        }
    };


    /**
     * Handle the tab Click event.
     * @param event - MouseClick Event.
     */
    TabsViewController.prototype.onTabButtonClicked = function (event) {
        var target = event.target || event.srcElement;

        for (var i = 0; i < this.tabs.length; i++) {
            if (this.tabs[i].button === target) {
                this.setActiveTab(i);
                break;
            }
        }

        event.preventDefault();
        event.stopPropagation();
    };


    return TabsViewController;

});
